export const ADDRESS_VALIDATION_API_URL =
	"https://addressvalidation.googleapis.com/v1:validateAddress?key=";
export const CORE_URL = "/core";
